const ProfileScreenTeacherPortal = ({
  userData,
  phone,
  address,
  updateProfile,
  setPhone,
  setAddress,
}) => {

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/teacherportal";
  }

  return (
    <div className="new-teacher-portal__profile">
      <div className="new-teacher-portal__back-arrow-wrapper">
        <div className="new-teacher-portal__header">
          <img
            className="new-teacher-portal__teacher-image"
            alt="teacher-pic"
            src={`https://app.atharo.app/images/${userData.ImageName}`}
          />
        </div>
        <div className="new-teacher-portal__header__name">{userData.Name}</div>
        <div className="new-teacher-portal__header__subtext">Music Teacher</div>
        <label className="new-teacher-portal__profile-input__label">
          Phone Number
        </label>
        <input
          className="new-teacher-portal__profile-input"
          id="new-teacher-portal__phone"
          value={phone}
          onBlur={(e) =>
            (document.getElementById(e.target.id).style.outline = "none")
          }
          onChange={(e) =>
            updateProfile(
              e.target.value,
              setPhone,
              "new-teacher-portal__phone",
              false
            )
          }
        />
        <label className="new-teacher-portal__profile-input__label">
          Street Address
        </label>
        <input
          className="new-teacher-portal__profile-input"
          id="new-teacher-portal__street"
          value={address.StreetAddress}
          onBlur={(e) =>
            (document.getElementById(e.target.id).style.outline = "none")
          }
          onChange={(e) =>
            updateProfile(
              e.target.value,
              setAddress,
              "new-teacher-portal__street",
              "StreetAddress"
            )
          }
        />
        <label className="new-teacher-portal__profile-input__label">City</label>
        <input
          className="new-teacher-portal__profile-input"
          id="new-teacher-portal__city"
          value={address.City}
          onBlur={(e) =>
            (document.getElementById(e.target.id).style.outline = "none")
          }
          onChange={(e) =>
            updateProfile(
              e.target.value,
              setAddress,
              "new-teacher-portal__city",
              "City"
            )
          }
        />
        <label className="new-teacher-portal__profile-input__label">
          State
        </label>
        <input
          className="new-teacher-portal__profile-input"
          id="new-teacher-portal__state"
          value={address.State}
          onBlur={(e) =>
            (document.getElementById(e.target.id).style.outline = "none")
          }
          onChange={(e) =>
            updateProfile(
              e.target.value,
              setAddress,
              "new-teacher-portal__state",
              "State"
            )
          }
        />
        <label className="new-teacher-portal__profile-input__label">
          Zip Code
        </label>
        <input
          className="new-teacher-portal__profile-input"
          id="new-teacher-portal__zip"
          value={address.Zip}
          onBlur={(e) =>
            (document.getElementById(e.target.id).style.outline = "none")
          }
          onChange={(e) =>
            updateProfile(
              e.target.value,
              setAddress,
              "new-teacher-portal__zip",
              "Zip"
            )
          }
        />
      </div>
      <div className="new-teacher-portal__log-out-wrapper">
        <div className="new-teacher-portal__log-out-btn" onClick={() => logOut()}>Logout</div>
      </div>
    </div>
  );
};
export default ProfileScreenTeacherPortal;
